import Variant from '../views/variants/Index.vue';
import { checkauth } from '../Helper';

// inserimento e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const VariantCreate = () => import('../views/variants/Create.vue');
const VariantEdit = () => import('../views/variants/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/variants',
		name: 'Variant',
		component: Variant,
		beforeEnter: auth,
	},
	{
		path: '/variants/new',
		name: 'variant-new',
		component: VariantCreate,
		beforeEnter: auth,
	},
	// :id e' l'_id della variante (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/variants/:id([0-9a-fA-F]{24})',
		name: 'variant-edit',
		component: VariantEdit,
		beforeEnter: auth,
	},
];
